import React from 'react';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import Services from '../components/Services';
import Team from '../components/Team';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';

import FAQ from '../components/FAQ';

const Home = () => {
    return (
        <>
            <Hero />
            <HowItWorks />
            <Services />
            <Team />
            <Testimonials />
            <FAQ />
            <Contact />
        </>
    );
};

export default Home;
